import { useOrderedCustomerTargetTableRows } from "../features/route-pair-target-table/hooks/UseOrderedCustomerTargetTableRows";
import { isDefined } from "@/lib/IsDefined";

export const useRoutePairTarget = () => {
  const filteredRouteCustomerTargetData =
    useOrderedCustomerTargetTableRows().filter(isDefined);

  return {
    data: filteredRouteCustomerTargetData,
  };
};
